import styles from "./AnswerOption.module.scss";

export default function AnswerOptionRadio({ text, value, name, selected, onChange }) {
	return (
		<label className={`${styles.answerOption} ${selected ? styles.optionSelected : ""}`} htmlFor={`for--${value}`}>
			<span className={styles.check}>
				<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
					<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
				</svg>
			</span>
			<span>
				<input type="radio" name={name} id={`for--${value}`} value={value} onChange={onChange} /> <strong>{text}</strong>
			</span>
		</label>
	);
}
